import { render, staticRenderFns } from "./MediaImage.vue?vue&type=template&id=18192ecd&"
import script from "./MediaImage.vue?vue&type=script&lang=ts&"
export * from "./MediaImage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports